import data from "@/data/podcast.json";

export const show = data.show;
export const episodes = data.episodes || [];
export const feedUrl = data.feedUrl;
export const generatedAt = data.generatedAt;

export const getLatest = () => episodes[0] || null;
export const getEpisodeBySlug = (slug) =>
  episodes.find((e) => e.slug === slug) || null;

export const getAdjacent = (slug) => {
  const i = episodes.findIndex((e) => e.slug === slug);
  return {
    newer: i > 0 ? episodes[i - 1] : null,
    older: i >= 0 && i < episodes.length - 1 ? episodes[i + 1] : null,
  };
};

export function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  } catch {
    return "";
  }
}

export function formatDuration(sec) {
  sec = Math.round(sec || 0);
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m ${String(s).padStart(2, "0")}s`;
}

export function formatClock(sec) {
  sec = Math.max(0, Math.round(sec || 0));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const mm = h > 0 ? String(m).padStart(2, "0") : String(m);
  return (h > 0 ? h + ":" : "") + mm + ":" + String(s).padStart(2, "0");
}
